import { Box } from '@mui/material';
import CategorySlider from 'components/common/CategorySlider';
import { useMemo } from 'react';
import useCategories from 'store/categories';

interface ICategorySliderListProps {
  categoryCount: number;
  gameCount: number;
}

const CategorySliderList = ({ categoryCount, gameCount }: ICategorySliderListProps) => {
  const [categories] = useCategories();

  const filteredCategories = useMemo(
    () => categories.data.filter((_, index) => index < categoryCount),
    [categories.data, categoryCount]
  );
  return (
    <Box display="flex" flexDirection="column" gap="24px" marginTop="16px">
      {filteredCategories.map((category) => (
        <CategorySlider key={category.id} categoryId={category.id} size={gameCount} />
      ))}
    </Box>
  );
};

export default CategorySliderList;
